<template>
  <div>
    <c-card title="작업환경측정결과 엑셀업로드" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable"
            label="LBLAPPLY"
            icon="save"
            @btnClicked="acceptData"
          />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <c-text
            :editable="editable"
            :disabled="true"
            label="요청부서/이름/일자"
            name="request"
            v-model="request"
          >
          </c-text>
        </div>
      </template>
    </c-card>
    <c-excel-upload :editable="editable" :excelUploadInfo="excelUploadInfo" />
  </div>
</template>

<script>
export default {
  name: "work-measure-result-excel-upload",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          requestContents: "",
          hazardClassFstCd: "",
          plantCd: "",
        };
      },
    },
  },
  data() {
    return {
      excelUploadInfo: {
        rowKeys: ["workMeasurementResultId"], // 데이터들의 키 속성값
        taskClassCd: "WMR_NOT_NOISE", // 엑셀업로드 양식 구분 값
        sheetNum: 0,
        columns: [
          [
            {
              name: "temp",
              field: "temp",
              label: "빈칸",
              type: "readonly",
              align: "left",
              style: "width:70px",
            },
            {
              name: "sortOrder",
              field: "sortOrder",
              label: "No.",
              type: "readonly",
              align: "left",
              style: "width:150px",
            },
            {
              name: "deptCd",
              field: "deptCd",
              label: "부서명",
              type: "readonly",
              align: "left",
              style: "width:150px",
            },
            {
              name: "process",
              field: "process",
              label: "공정코드",
              type: "readonly",
              align: "left",
              style: "width:150px",
            },
            {
              name: "processCd",
              field: "processCd",
              label: "공정명",
              type: "readonly",
              align: "left",
              style: "width:200px",
            },
            {
              required: true,
              name: "workPlace",
              field: "workPlace",
              label: "단위작업장소",
              align: "left",
              style: "width:150px",
            },
            {
              name: "hazardCd",
              field: "hazardCd",
              label: "유해인자코드",
              align: "left",
              type: "readonly",
              style: "width:150px",
            },
            {
              name: "hazardName",
              field: "hazardName",
              label: "유해인자명",
              align: "left",
              type: "harmFulFactor",
              style: "width:150px",
            },
            {
              name: "workCount",
              field: "workCount",
              label: "근로자수",
              align: "right",
              style: "width:150px",
            },
            {
              name: "shiftType",
              field: "shiftType",
              label: "근로형태",
              align: "left",
              style: "width:150px",
            },
            {
              name: "occurTime",
              field: "occurTime",
              label: "발생시간",
              align: "center",
              style: "width:150px",
            },
            {
              name: "measPositionName",
              field: "measPositionName",
              label: "측정위치",
              align: "left",
              style: "width:150px",
            },
            {
              name: "workerName",
              field: "workerName",
              label: "근로자명",
              align: "center",
              style: "width:150px",
            },
            // {
            //   name: 'workerName',
            //   field: 'workerName',
            //   label: '근로자명',
            //   align: 'center',
            //   type: 'user',
            //   userId: 'workerUserId',
            //   style: 'width:150px',
            // },
            {
              name: "measStartTime",
              field: "measStartTime",
              label: "시작시간",
              align: "center",
              type: "time",
              style: "width:150px",
            },
            {
              name: "measEndTime",
              field: "measEndTime",
              label: "종료시간",
              type: "time",
              align: "center",
              style: "width:150px",
            },
            {
              name: "captureTime",
              field: "captureTime",
              label: "포집시간",
              align: "center",
              style: "width:150px",
            },
            {
              name: "measCount",
              field: "measCount",
              label: "측정횟수",
              align: "center",
              style: "width:150px",
            },
            {
              name: "measValueEtc",
              field: "measValueEtc",
              label: "측정치기타",
              align: "left",
              style: "width:150px",
            },
            {
              name: "measValue",
              field: "measValue",
              label: "측정치",
              align: "right",
              style: "width:150px",
            },
            {
              name: "twaPrevEtc",
              field: "twaPrevEtc",
              label: "전회기타",
              align: "left",
              style: "width:150px",
            },
            {
              name: "twaPrev",
              field: "twaPrev",
              label: "전회",
              align: "right",
              style: "width:150px",
            },
            {
              name: "twaCurrEtc",
              field: "twaCurrEtc",
              label: "금회기타",
              align: "left",
              style: "width:150px",
            },
            {
              name: "twaCurr",
              field: "twaCurr",
              label: "금회",
              align: "right",
              style: "width:150px",
            },
            {
              name: "afterExposureStandard",
              field: "afterExposureStandard",
              label: "보정후 노출기준",
              align: "right",
              style: "width:150px",
            },
            {
              name: "exposureDivision",
              field: "exposureDivision",
              label: "노출구분",
              align: "left",
              style: "width:150px",
            },
            {
              name: "exposureUnit",
              field: "exposureUnit",
              label: "노출단위",
              align: "left",
              style: "width:150px",
            },
            {
              name: "exposureResult",
              field: "exposureResult",
              label: "결과",
              align: "center",
              style: "width:150px",
            },
            {
              name: "collectionMethod",
              field: "collectionMethod",
              label: "채취방법",
              align: "left",
              style: "width:150px",
            },
            {
              name: "analyzeCode",
              field: "analyzeCode",
              label: "분석코드",
              align: "left",
              style: "width:150px",
            },
            {
              name: "analyzeMethod",
              field: "analyzeMethod",
              label: "분석방법",
              align: "center",
              style: "width:150px",
            },
            {
              name: "occurrenceCycleName",
              field: "occurrenceCycleName",
              label: "발생주기명",
              align: "center",
              style: "width:150px",
            },
            {
              name: "exposureTime",
              field: "exposureTime",
              label: "폭로시간",
              align: "center",
              style: "width:150px",
            },
            {
              name: "measTypeFst",
              field: "measTypeFst",
              label: "측정구분",
              align: "left",
              style: "width:150px",
            },
            {
              name: "remark",
              field: "remark",
              label: "비고",
              align: "left",
              style: "width:150px",
            },
            {
              name: "beforeExposureStandard",
              field: "beforeExposureStandard",
              label: "보정전노출기준",
              align: "right",
              style: "width:150px",
            },
            {
              name: "measUser",
              field: "measUser",
              label: "측정자",
              align: "center",
              style: "width:150px",
            },
            {
              name: "integratedType",
              field: "integratedType",
              label: "통합구분",
              align: "left",
              style: "width:150px",
            },
            {
              name: "groupType",
              field: "groupType",
              label: "그룹구분",
              align: "left",
              style: "width:150px",
            },
            {
              name: "chemGroupCd",
              field: "chemGroupCd",
              label: "취급물질그룹코드",
              align: "left",
              style: "width:150px",
            },
            {
              name: "chemGroupOrder",
              field: "chemGroupOrder",
              label: "취급물질그룹순번",
              align: "left",
              style: "width:150px",
            },
            {
              name: "measDate",
              field: "measDate",
              label: "측정일자",
              type: "date",
              align: "center",
              style: "width:150px",
            },
            {
              name: "analysisRequest",
              field: "analysisRequest",
              label: "분석의뢰",
              align: "center",
              style: "width:150px",
            },
            {
              name: "groupCd",
              field: "groupCd",
              label: "공정,단위작업장소그룹",
              align: "center",
              style: "width:150px",
            },
            {
              name: "measTypeSec",
              field: "measTypeSec",
              label: "측정구분",
              align: "center",
              style: "width:150px",
            },
            {
              name: "excludingNoise",
              field: "excludingNoise",
              label: "소음제외키값",
              align: "center",
              style: "width:150px",
            },
            {
              name: "exposureStdExceeded",
              field: "exposureStdExceeded",
              label: "노출기준초과",
              align: "center",
              style: "width:150px",
            },
            {
              name: "occupationCode",
              field: "occupationCode",
              label: "직종코드",
              align: "center",
              style: "width:150px",
            },
            {
              name: "occupationName",
              field: "occupationName",
              label: "직종명",
              align: "center",
              style: "width:150px",
            },
            {
              name: "fstTrace",
              field: "fstTrace",
              label: "Trace",
              align: "center",
              style: "width:150px",
            },
            {
              name: "secTrace",
              field: "secTrace",
              label: "Trace",
              align: "center",
              style: "width:150px",
            },
            {
              name: "etc",
              field: "etc",
              label: "이외",
              align: "center",
              style: "width:150px",
            },
          ],
        ],
        data: [],
        deptCd: "",
        processCd: "",
        workplace: "",
      },
      changeItem: {
        plant: "",
        process: "",
        vendor: "",
      },
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    request() {
      return (
        this.$store.getters.user.deptName +
        " / " +
        this.$store.getters.user.userName +
        " / " +
        this.$comm.getToday()
      );
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code
      // list setting
    },
    acceptData() {
      if (this.excelUploadInfo.data) {
        let dataCntCheck = true;
        let errorDataCheck = false;
        if (
          !this.excelUploadInfo.data[0] ||
          this.excelUploadInfo.data[0].length === 0
        ) {
          dataCntCheck = false;
        }
        if (
          this.$_.findIndex(this.excelUploadInfo.data[0], (item) => {
            return item.error_message;
          }) > -1
        ) {
          errorDataCheck = true;
        }

        if (!dataCntCheck) {
          window.getApp.$emit("ALERT", {
            title: "LBLGUIDE", // 안내
            message:
              "업로드할 데이터가 없는 Sheet가 있습니다.\n데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.",
            type: "warning", // success / info / warning / error
          });
        } else {
          if (errorDataCheck) {
            window.getApp.$emit("CONFIRM", {
              title: "LBLCONFIRM",
              message:
                "에러가 있는 데이터가 존재합니다.\n에러 있는 데이터를 제외한 나머지 데이터를 적용하시겠습니까?",
              // TODO : 필요시 추가하세요.
              type: "info", // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                this.$emit("closePopup", this.excelUploadInfo.data[0]);
              },
              // 취소 callback 함수
              cancelCallback: () => {},
            });
          } else {
            this.$emit("closePopup", this.excelUploadInfo.data[0]);
          }
        }
      }
    },
  },
};
</script>
